import { useQuery } from "@tanstack/react-query";
import {
  getSearchBrowseSections,
  SEARCH_BROWSE_SECTIONS_KEY,
} from "../api/searchV2Api";

export function useSearchBrowseSections(context: string) {
  return useQuery({
    queryKey: [...SEARCH_BROWSE_SECTIONS_KEY, context],
    queryFn: ({ signal }) => getSearchBrowseSections(context, signal),
    select: (res) => res.data.payload.results,
    staleTime: 5 * 60_000,
  });
}
